module.exports = __webpack_public_path__ + "static/img/popup-ratate.779badaa.png";